export default __webpack_public_path__ + "static/media/OSMOS_TORTORA-RIBBED_60X120_06.e5e45cf8.jpg";